import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=21a7b609"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=21a7b609&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports